import i2Add from './i2Add'
import i2Sub from './i2Sub'
import i2Multiply from './i2Multiply'
import i2Division from './i2Division'

const i2Math = {
  i2Add,
  i2Sub,
  i2Multiply,
  i2Division
}
export default i2Math
